// src/stores/useUserRoleStore.ts
import { create } from 'zustand';

type UserRole = 'talent' | 'business' | 'admin';

interface UserRoleStore {
  role: UserRole;
  setRole: (role: UserRole) => void;
  activeTalentId: string | null;
  setActiveTalentId: (id: string) => void;
}

export const useUserRoleStore = create<UserRoleStore>((set) => ({
  role: 'talent',
  setRole: (role) => set({ role }),
  activeTalentId: 'talent_001',
  setActiveTalentId: (id) => set({ activeTalentId: id }),
}));
